var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { Avatar, Box, MenuItem, Stack, TextField } from "@mui/material";
import { ContainerForm } from "../../components/ContainerForm";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { FormButton, FormButtonType } from "../../components/FormButton";
import AppBarHeader from "../../components/Home/AppBarHeader";
import { Loading } from "../../components/Loading";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { useAuth } from "../../hooks/useAuth";
import { obterCidades } from "../../services/generico.service";
import { obterDadosCondutor, obterFoto, solicitarCnhDefinitiva, } from "../../services/habilitacao.service";
import { extrairCodigoArea, extrairNumero } from "../../util/formatadores";
import { formatarCpf } from "../../util/mascaras";
import { cnhDefinitivaSchema } from "../../validators/habilitacaoSchema";
import { AlterarEndereco } from "./AlterarEndereco";
var tiposEnviosCarteira = [
    // {
    //   label: "Correios",
    //   valor: "C",
    // },
    {
        label: "Detran",
        valor: "D",
    },
];
var tiposFotoCondutor = [
    {
        label: "Reaproveitar foto atual",
        valor: "1",
    },
    {
        label: "Tirar nova foto no Detran",
        valor: "0",
    },
];
export var CnhDefinitiva = function () {
    var userInfo = useAuth().userInfo;
    var navigate = useNavigate();
    var _a = useState(), dados = _a[0], setDados = _a[1];
    var _b = useState(), erro = _b[0], setErro = _b[1];
    var _c = useState(false), sucesso = _c[0], setSucesso = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(""), cpf = _e[0], setCpf = _e[1];
    var _f = useState(null), ciretrans = _f[0], setCiretrans = _f[1];
    var _g = useState(false), inputEnderecoAlterado = _g[0], setInputEnderecoAlterado = _g[1];
    var _h = useState(null), photoSrc = _h[0], setPhotoScr = _h[1];
    var cnhDefinitivaForm = useForm({
        resolver: zodResolver(cnhDefinitivaSchema),
        defaultValues: {
            celSms: "",
            cpf: "",
            ddd: "",
            envioCarteira: "",
            numeroRenach: "",
            idCiretran: "",
            fotoCondutor: "",
        },
    });
    var register = cnhDefinitivaForm.register, handleSubmit = cnhDefinitivaForm.handleSubmit, errors = cnhDefinitivaForm.formState.errors, control = cnhDefinitivaForm.control;
    var handleRegistrarSolicitacao = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setErro(undefined);
                    setLoading(true);
                    payload = {
                        cpf: data.cpf,
                        ddd: data.ddd,
                        celSms: data.celSms,
                        numeroRenach: data.numeroRenach,
                        envioCarteira: data.envioCarteira,
                        idCiretran: data.idCiretran,
                        fotoCondutor: data.fotoCondutor,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, solicitarCnhDefinitiva(payload)];
                case 2:
                    _b.sent();
                    setSucesso(true);
                    setTimeout(function () {
                        navigate("/home");
                    }, 1000);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    setErro((_a = error_1.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao registrar solicitação");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var verificarCiretransPorMunicipio = function (municipios) {
        if (dados === null || dados === void 0 ? void 0 : dados.idCidadePaisEndereco) {
            var cidades = municipios
                .filter(function (municipio) { return municipio.idCidadePais === (dados === null || dados === void 0 ? void 0 : dados.idCidadePaisEndereco); })
                .flatMap(function (item) { return item.ciretranMunicipio; });
            if (cidades.length !== 0) {
                return cidades;
            }
            else {
                return municipios.flatMap(function (municipio) { return municipio.ciretranMunicipio; });
            }
        }
        else {
            return municipios.flatMap(function (municipio) { return municipio.ciretranMunicipio; });
        }
    };
    useEffect(function () {
        var fetchDados = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _b.sent();
                        cnhDefinitivaForm.reset({
                            cpf: response.cpf,
                            ddd: extrairCodigoArea(response.telefone) || "",
                            celSms: extrairNumero(response.telefone) || "",
                            numeroRenach: response.numeroRenach,
                        });
                        setDados(response);
                        setCpf(response.cpf);
                        fetchFoto();
                        fetchCidades();
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _b.sent();
                        setErro((_a = error_2.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao recuperar dados do condutor");
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var fetchFoto = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(dados === null || dados === void 0 ? void 0 : dados.numeroRenach)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                            numeroRenach: dados.numeroRenach,
                        };
                        return [4 /*yield*/, obterFoto(payload)];
                    case 2:
                        response = _a.sent();
                        setPhotoScr(response.fotoBase64);
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        console.error(error_3);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var fetchCidades = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_4;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(dados === null || dados === void 0 ? void 0 : dados.ufEmissao)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, obterCidades(dados.ufEmissao)];
                    case 2:
                        response = _b.sent();
                        setCiretrans(verificarCiretransPorMunicipio(response));
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _b.sent();
                        setErro((_a = error_4.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao listar cidades");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchDados();
    }, [cnhDefinitivaForm, userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username, dados === null || dados === void 0 ? void 0 : dados.ufEmissao]);
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "Solicitar troca da CNH tempor\u00E1ria para CNH definitiva", voltarPara: "/home" }), _jsx(Loading, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "Solicitar troca da CNH tempor\u00E1ria para CNH definitiva", isHabilitacao: true }), _jsx(FormProvider, __assign({}, cnhDefinitivaForm, { children: _jsx("form", __assign({ onSubmit: handleSubmit(handleRegistrarSolicitacao) }, { children: _jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsxs(ContainerForm, __assign({ title: "Dados Pessoais" }, { children: [_jsx(TextField, __assign({ id: "cpf", label: "CPF", variant: "outlined", value: formatarCpf(cpf), InputLabelProps: {
                                                shrink: true,
                                            }, inputProps: {
                                                maxLength: 11,
                                            } }, register("cpf", {
                                            onChange: function (e) { return setCpf(formatarCpf(e.target.value)); },
                                        }), { error: errors.cpf !== undefined, helperText: errors.cpf && errors.cpf.message, disabled: true })), _jsxs(Stack, __assign({ direction: "row", gap: "0.5rem" }, { children: [_jsx(TextField, __assign({ id: "ddd", label: "DDD", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, inputProps: {
                                                        maxLength: 2,
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                    } }, register("ddd", {
                                                    onChange: function (e) {
                                                        var valorNumerico = e.target.value.replace(/\D/g, "");
                                                        e.target.value = valorNumerico;
                                                    },
                                                }), { error: errors.ddd !== undefined, helperText: errors.ddd && errors.ddd.message, sx: { width: "20%" } })), _jsx(TextField, __assign({ id: "celSms", label: "Celular", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, inputProps: {
                                                        maxLength: 9,
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                    } }, register("celSms", {
                                                    onChange: function (e) {
                                                        var valorNumerico = e.target.value.replace(/\D/g, "");
                                                        e.target.value = valorNumerico;
                                                    },
                                                }), { error: errors.celSms !== undefined, helperText: errors.celSms && errors.celSms.message, sx: { width: "90%" } }))] }))] })), _jsx(AlterarEndereco, { setInputAlterado: function (valor) { return setInputEnderecoAlterado(valor); } }), _jsxs(ContainerForm, __assign({ title: "Dados Gerais" }, { children: [_jsx(TextField, __assign({ id: "numeroRenach", label: "N\u00FAmero Renach", variant: "outlined", InputLabelProps: {
                                                shrink: true,
                                            }, inputProps: {
                                                maxLength: 11,
                                            } }, register("numeroRenach"), { error: errors.numeroRenach !== undefined, helperText: errors.numeroRenach && errors.numeroRenach.message, disabled: true })), _jsx(Controller, { name: "envioCarteira", defaultValue: "D", control: control, render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref;
                                                return (_jsx(TextField, __assign({ select: true, id: "envioCarteira", label: "Envio da Carteira", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, onChange: onChange, onBlur: onBlur, value: value, inputRef: ref, error: errors.envioCarteira !== undefined, helperText: errors.envioCarteira && errors.envioCarteira.message, disabled: true }, { children: tiposEnviosCarteira.map(function (tipo) { return (_jsx(MenuItem, __assign({ value: tipo.valor }, { children: tipo.label }), tipo.valor)); }) })));
                                            } }), _jsx(Controller, { name: "idCiretran", control: control, render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref;
                                                return (_jsx(TextField, __assign({ select: true, id: "idCiretran", label: "Ciretran", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, onChange: onChange, onBlur: onBlur, value: value, inputRef: ref, error: errors.idCiretran !== undefined, helperText: errors.idCiretran && errors.idCiretran.message }, { children: ciretrans === null || ciretrans === void 0 ? void 0 : ciretrans.map(function (ciretran) { return (_jsx(MenuItem, __assign({ value: ciretran === null || ciretran === void 0 ? void 0 : ciretran.idCiretran }, { children: ciretran === null || ciretran === void 0 ? void 0 : ciretran.nomeCiretran }), ciretran === null || ciretran === void 0 ? void 0 : ciretran.idCiretran)); }) })));
                                            } }), _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [photoSrc && (_jsx(Avatar, { src: "data:image/jpeg;base64,".concat(photoSrc), variant: "square", sx: { width: "8rem", height: "8rem" } })), _jsx(Controller, { name: "fotoCondutor", control: control, defaultValue: "0", render: function (_a) {
                                                        var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref;
                                                        return (_jsx(TextField, __assign({ select: true, id: "fotoCondutor", label: "Deseja reaproveitar a foto atual ou solicitar uma nova foto?", variant: "outlined", InputLabelProps: {
                                                                shrink: true,
                                                            }, onChange: onChange, onBlur: onBlur, value: value, inputRef: ref, error: errors.fotoCondutor !== undefined, helperText: errors.fotoCondutor && errors.fotoCondutor.message, sx: { flexGrow: "1" }, disabled: !photoSrc }, { children: tiposFotoCondutor.map(function (tipo) { return (_jsx(MenuItem, __assign({ value: tipo.valor }, { children: tipo.label }), tipo.valor)); }) })));
                                                    } })] }))] })), _jsxs(Stack, __assign({ direction: { md: "row-reverse" }, marginY: "2rem", sx: { gap: "1rem" } }, { children: [_jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Enviar", onClick: function () { return null; }, isSubmit: true, isDisabled: !inputEnderecoAlterado }), _jsx(FormButton, { type: FormButtonType.SECONDARY, title: "Voltar", onClick: function () { return navigate("/home"); } })] }))] }) })) })) })), sucesso && (_jsx(SnackbarFeedback, { isOpen: true, type: "success", message: "Solicita\u00E7\u00E3o realizada com sucesso" })), erro && (_jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" }))] }));
};
